module.exports = __webpack_public_path__ + "img/splash-shadow-bg.6edad2b1.jpg";